<template>
  <v-progress-linear
    v-if="value !== undefined && value !== null"
    class="table-value-progress"
    :color="color"
    background-opacity="0"
    height="30px"
    :value="max > 0 ? Math.max(5, (value / max) * 100) : 0"
  >
    <slot />
  </v-progress-linear>
  <div
    v-else
    class="grey--text caption"
  >
    N/A
  </div>
</template>

<script>
export default {
  name: 'TableBarValue',
  props: {
    value: {
      type: [Number, String],
      default: undefined
    },
    max: {
      type: Number,
      default: 100
    },
    color: {
      type: String,
      default: 'grey lighten-2'
    }
  }
}
</script>

<style scoped>

</style>
